import { useEffect, useState } from "react";
import { useNavigation } from "react-router";

const SiteLoadingIndicator = () => {
  const navigation = useNavigation();
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  const isLoading =
    navigation.state === "loading" || navigation.state === "submitting";

  useEffect(() => {
    if (isLoading) {
      setIsVisible(true);
      setProgress(10); // Start at 10%

      // Simulate progress
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 90) return prev; // Don't go to 100% until actually done
          return prev + Math.random() * 30;
        });
      }, 200);

      return () => clearInterval(interval);
    } else {
      // Complete the progress when loading is done
      setProgress(100);

      // Hide after animation completes
      const timeout = setTimeout(() => {
        setIsVisible(false);
        setProgress(0);
      }, 200);

      return () => clearTimeout(timeout);
    }
  }, [isLoading]);

  if (!isVisible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50 h-0.5 bg-gray-200">
      <div
        className="h-full bg-action-quiet transition-all duration-200 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export default SiteLoadingIndicator;
